/*
This page is here to test specific scenarios wich copilot
can't seem to fix. When it tries playright it goes wrong
because of the forced login redirect. This page is outside the 
forced redirect and ideal for some tests
should be removed when no longer needed
*/
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { YdsComboboxComponent, YdsDropdownComponent, type YdsDropdownOption } from '../yds-angular';

@Component({
  selector: 'app-test-dropdown',
  standalone: true,
  imports: [FormsModule, YdsDropdownComponent, YdsComboboxComponent],
  templateUrl: './test-dropdown.component.html',
  styleUrl: './test-dropdown.component.scss',
})
export class TestDropdownComponent {
  selectedFirst: string | null = null;
  selectedSecond: string | null = null;
  selectedThird: string | null = null;
  selectedFourth: string | null = null;

  readonly firstOptions: readonly YdsDropdownOption[] = [
    { id: '1', label: 'Short' },
    { id: '2', label: 'A medium length item' },
    { id: '3', label: 'This is a considerably longer item label' },
    { id: '4', label: 'An extremely long dropdown item label that should overflow the available width' },
  ];

  readonly secondOptions: readonly YdsDropdownOption[] = [
    { id: '1', label: 'Tiny' },
    { id: '2', label: 'Some moderate text' },
    { id: '3', label: 'A noticeably longer option to display here' },
    { id: '4', label: 'Yet another exceptionally long option label used to verify the max-width truncation behaviour' },
  ];
}
